export default "__VITE_ASSET__CCFcm4WH__"